import { useQuery } from "react-query";
import { getCheckpoints } from "../api";
import useOrganizationContext from "../../hooks/useOrganizationContext";

const useCheckpoints = ({ queryOptions = {}, queryParams = {} } = {}) => {
	const organization = useOrganizationContext();
	const organizationId = organization?.id();

	return useQuery(
		["checkpoints", organizationId, queryParams],
		() => getCheckpoints(organizationId, queryParams),
		queryOptions
	);
};

export default useCheckpoints;
